document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('NurielleHeader');
  const mobileToggle = document.querySelector('.nurielle-mobile-toggle');
  const mobileDrawer = document.querySelector('.nurielle-mobile-drawer');
  const drawerClose = document.querySelector('.drawer-close');

  // --- 1. STICKY HEADER LOGIC ---
  if (header) {
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > 100) {
        header.classList.add('nurielle-sticky');
      } else {
        header.classList.remove('nurielle-sticky');
      }
    });
  }

  // --- 2. MOBILE DRAWER LOGIC ---
  if (mobileDrawer) {
    const openDrawer = () => {
      mobileDrawer.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevents background scrolling when drawer is open
    };

    const closeDrawer = () => {
      mobileDrawer.classList.remove('active');
      document.body.style.overflow = ''; // Restores background scrolling
    };

    // Open drawer on mobile toggle button click
    if (mobileToggle) {
      mobileToggle.addEventListener('click', openDrawer);
    }

    // Close drawer on close button click
    if (drawerClose) {
      drawerClose.addEventListener('click', closeDrawer);
    }

    // Close drawer when clicking outside of it
    document.addEventListener('click', (e) => {
      if (
        mobileDrawer.classList.contains('active') &&
        !mobileDrawer.contains(e.target) &&
        !mobileToggle.contains(e.target)
      ) {
        closeDrawer();
      }
    });

    // Close drawer on Escape key press
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileDrawer.classList.contains('active')) {
        closeDrawer();
      }
    });
  }
});